<!--指标收款报表-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search
        :data="tableFilterList(tableHead)"
        @search="dataTableSearch"
      >
        <!-- <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add()">新增</el-button>
        </template> -->
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="20"
        :page="page"
        :loading="loading"
        stripe
        :spanMethod="spanMethod"
        border
        :toolBar="{ hidden: true}"
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { tableSataus } from "@/views/bill/mixins/status";

export default {
  name: "PartnerBudgetTask",
  components: {
    DynamicSearch
  },
  mixins: [DataTableMixin, tableSataus],
  data() {
    return {
      tableHead: [
        {
          label: "合伙人",
          prop: "name",
          align: "center",
          query: {
            type: "input"
          },
        },
        {
          label: "合伙人部门",
          prop: "taskDept",
           align: "center",
        },
        {
          label: "年度",
          prop: "taskYear",
          align: "center",
          query: {
            type: "input"
          }
        },
        {
          label: "指标金额",
          prop: "taskMoney",
          align: "center",
        },
         {
          label: "季度",
          prop: "quarterName",
           align: "center",
        },
        {
          label: "季度占比",
          prop: "percent",
           align: "right",
        },
        {
          label: "预测金额",
          prop: "forecastMoney",
           align: "right",
        },
        {
          label: "当期签约金额",
          prop: "currentContractMoney",
           align: "right",
        },
        {
          label: "当期回款金额",
          prop: "currentMoneyBack",
           align: "right",
        }
      ],
      spanArr: [],
      position: 0,
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
	});
  },
  watch: {
      list: {
          handler(val) {
              this.rowspan(0,"name")
              this.rowspan(1,"taskDept")
              this.rowspan(2,"taskYear")
              this.rowspan(3,"taskMoney")
              },
          deep: true
          }
  },
  methods: {
    dataTableBeforeInit() {
      this._url = "/reportForms/indicatorsOf";
      const params = { page: this.page, size: 20 };
      this._params = Object.assign(params, this._query);
      return true;
    },
    /**
     * 单元格合并
     */
    spanMethod({ row, column, rowIndex, columnIndex }) {
      for (let i = 0; i < 4; i++) {
        if (columnIndex === i) {
          const _row = this.spanArr[i][rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col
          };
        }
      }
	},
	rowspan(idx, prop) {
      this.spanArr[idx] = [];
      this.position = 0;
      this.list.forEach((item, index) => {
        if (index === 0) {
          this.spanArr[idx].push(1);
          this.position = 0;
        } else {
          if (this.list[index][prop] === this.list[index - 1][prop] && this.as(idx,prop,index)) {
            this.spanArr[idx][this.position] += 1; // 有相同项
            this.spanArr[idx].push(0); // 名称相同后往数组里面加一项0
          } else {
            this.spanArr[idx].push(1); // 同列的前后两行单元格不相同
            this.position = index;
          }
        }
      });
	},
	as(idx,prop,index) {
		if (idx === 0) return true
		if (idx === 1 && this.list[index]["name"] === this.list[index - 1]["name"]) {
			return true
		} else if (idx === 2 && this.list[index]["name"] === this.list[index - 1]["name"]) {
			return true
		} else if (idx === 3 && this.list[index]["name"] === this.list[index - 1]["name"]) {
			return true
		}  else {
			return false
		}
	}
  }
};
</script>

<style scoped lang="scss">
/deep/ .el-table--border td {
  border-right: 1px solid #dfe6ec !important;
}
/deep/ .el-table__header-wrapper thead{
      color: #606266;
    font-weight: 600;
    // background-color: #FBFBFB;
}
/deep/ .el-table__header-wrapper thead tr > th{
   background-color: #FBFBFB;
}
</style>
